import { Skeleton } from '@mui/material';
import { useIntl } from 'react-intl';

import { useSimpleEventView } from '@verantos-dev/app-state-cohort-builder';

import { useSimpleEventCohortSection } from './hooks/useSimpleEventCohortSection';
import { CohortBuilderItemViewCard } from '../../../../components/CohortBuilderItemViewCard/CohortBuilderItemViewCard';
import { CohortSection } from '../../../../components/CohortSection/CohortSection';
import { useEmitResearchAssistantUpdate } from '../../../../hooks/common/useResearchAssistantUpdateForStudyPeriodCard';
import { SimpleEventEditCard } from '../../cohort-builder-edit-cards/SimpleEventEditCard/SimpleEventEditCard';

export const SimpleEventSection = () => {
  const intl = useIntl();

  const {
    simpleEvents,
    showSimpleEventEditModal,
    onAddSimpleEventClick,
    onEditSimpleEventClick,
    onDeleteSimpleEventClick,
    isLoading,
    viewMode,
  } = useSimpleEventView();
  const { emptyStateProps, headerProps } = useSimpleEventCohortSection(onAddSimpleEventClick);
  const emitResearchAssistantUpdate = useEmitResearchAssistantUpdate(viewMode);

  if (isLoading) {
    return (
      <CohortSection headerProps={headerProps} emptyStateProps={emptyStateProps}>
        <Skeleton variant="rectangular" height={78} />
        <Skeleton variant="rectangular" height={78} />
      </CohortSection>
    );
  }

  return (
    <>
      <CohortSection headerProps={headerProps} emptyStateProps={emptyStateProps}>
        {simpleEvents && simpleEvents.length > 0 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            {simpleEvents.map(({ id, name, type, isInUse, inUseItems }, index) => (
              <CohortBuilderItemViewCard
                key={id}
                id={id}
                isInUse={isInUse}
                viewMode={viewMode}
                inUseCohortBuilderItems={inUseItems}
                fields={[
                  {
                    id: `${id}-name`,
                    label: intl.formatMessage({
                      id: 'projects.cohortBuilder.simpleEventsSection.eventItemLabel',
                    }),
                    value: name,
                  },
                  {
                    id: `${id}-type`,
                    label: intl.formatMessage({
                      id: 'projects.cohortBuilder.simpleEventsSection.typeItemLabel',
                    }),
                    value:
                      (type?.slice(0, 1) ?? '') +
                      (type?.toLowerCase().replace(/_/g, ' ').slice(1) ?? ''),
                  },
                ]}
                onEditClick={onEditSimpleEventClick}
                onDeleteClick={onDeleteSimpleEventClick(emitResearchAssistantUpdate)}
              />
            ))}
          </div>
        )}
      </CohortSection>
      {showSimpleEventEditModal && <SimpleEventEditCard />}
    </>
  );
};
